<template>
  <div class="grid grid-cols-2">
    <div
      v-for="image in shuffledImages"
      :key="image.url"
      class="aspect-h-5 aspect-w-4 bg-white cursor-pointer"
      @click="openMediaDialog(image)"
    >
      <UiAsset :asset="image" :product-data="productData" />
    </div>
  </div>
  <DialogsImagePreviewDialog
    v-model="openDialog"
    :type="activeImage?.type"
    :alt="activeImage?.alt"
    :src="activeImage"
  />
</template>

<script setup lang="ts">
import { ProductData, assetsTypes } from "ecom-types";

// TODO: Need to replace to MF
interface ImageData {
  alt?: string;
  url: string;
  type?: string;
  listType?: string;
}
const props = defineProps<{
  images: ImageData[];
  productData?: ProductData;
  productImages?: ImageData[];
  diamondImages?: ImageData[];
  isDiamond?: boolean;
}>();

enum ActiveImgOptions {
  product = "product",
  diamond = "diamond",
}

const activeImageType = ref(
  props.isDiamond ? ActiveImgOptions.diamond : ActiveImgOptions.product,
);

const activeImages = computed<ImageData[]>(() => {
  const images =
    props.productImages?.length && props.diamondImages?.length
      ? activeImageType.value === ActiveImgOptions.product
        ? props.productImages
        : props.diamondImages
      : props.images;

  if (
    (props.productData?.view360_url || props.productData?.movies?.[0]?.url) &&
    activeImageType.value === ActiveImgOptions.diamond
  ) {
    const assetObj = { type: "", url: "", listType: "render" };
    if (props.productData?.view360_url) {
      assetObj.url = props.productData.view360_url || "";
      assetObj.type = assetsTypes.v360;
    } else if (props.productData?.movies?.[0]?.url) {
      assetObj.url = props.productData?.movies?.[0]?.url || "";
      assetObj.type = assetsTypes.video;
    }
    return props.isDiamond ? [assetObj, ...images] : [...images, assetObj];
  }
  return images;
});
const openDialog = ref(false);
const shuffledImages = computed<ImageData[]>(() => {
  const renders = activeImages.value.filter(
    (item) => item.listType === "render",
  );
  const media = activeImages.value.filter((item) => item.listType === "media");
  return shuffleMedia(renders, media);
});
const activeImage = ref<ImageData>(shuffledImages.value?.[0]);

function shuffleMedia(renders: ImageData[], media: ImageData[]): ImageData[] {
  const result: ImageData[] = [];
  const mediaListSize = renders.length + media.length;
  let index = 0;
  let isRender = true;
  while (index < mediaListSize) {
    const listSource: ImageData[] =
      (isRender || !media.length) && renders.length ? renders : media;
    result.push(...listSource.splice(0, 1));
    if (!index || index % 2 === 0) {
      isRender = !isRender;
    }
    index++;
  }
  return result;
}

function openMediaDialog(image: ImageData) {
  activeImage.value = image;
  openDialog.value = true;
}
</script>
